<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        维保项目详情
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>
    <div class="l-page__body l-page--detail__body">
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="project"
        >
          <el-form
            :inline="true"
            label-suffix="："
            label-position="right"
            label-width="150px"
            class="c-form"
          >
            <el-row class="c-form__row">
              <el-col
                class="c-form__col c-form__part-title"
                :span="24"
              >
                项目基础信息
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="项目编号"
                >
                  <span class="c-form__read">{{ detail.xmbh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="项目名称"
                >
                  <span class="c-form__read">{{ detail.xmmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="委托单位"
                >
                  <span class="c-form__read">{{ detail.wtdwmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="统一社会信用代码"
                >
                  <span class="c-form__read">{{ detail.wtdwshxydm || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="委托单位联系人"
                >
                  <span class="c-form__read">{{ detail.wtdwlxr || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="委托单位联系电话"
                >
                  <span class="c-form__read">{{ detail.wtdwlxdh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="维保单位"
                >
                  <span class="c-form__read">{{ detail.wbdwmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="所属区域"
                >
                  <span class="c-form__read">{{ detail.areaMc || detail.xzqydm || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-form-item
                  class="c-form__item"
                  label="项目地址"
                >
                  <span class="c-form__read">{{ detail.xmdz || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="消防安全管理人"
                >
                  <span class="c-form__read">{{ detail.xfaqglr || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="联系电话"
                >
                  <span class="c-form__read">{{ detail.xfaqglrdh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="物业管理单位"
                >
                  <span class="c-form__read">{{ detail.wygldw || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="项目状态"
                >
                  <span class="c-form__read">{{ detail.xmztMc || detail.xmzt || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-form-item
                  class="c-form__item"
                  label="项目概况"
                >
                  <span class="c-form__read">{{ detail.xmgs || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-form-item
                  class="c-form__item"
                  label="维保设施系统"
                >
                  <el-tag
                    v-for="item in detail.ssflList || []"
                    :key="item.uuid"
                    class="u-mg-r-5 u-mg-b-5"
                    size="small"
                  >
                    {{ item.ssmc }}
                  </el-tag>
                  <span
                    v-if="!(detail.ssflList || []).length"
                    class="c-form__read"
                  >-</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col c-form__part-title"
                :span="24"
              >
                合同信息
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="合同名称"
                >
                  <span class="c-form__read">{{ detail.htmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="合同编号"
                >
                  <span class="c-form__read">{{ detail.htbh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="合同金额（元）"
                >
                  <span class="c-form__read">{{ detail.htje || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="12"
              >
                <el-form-item
                  class="c-form__item"
                  label="合同有效期"
                >
                  <span class="c-form__read">{{ formatDate(detail.htyxqQ) }} 至 {{ formatDate(detail.htyxqZ) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col c-form__part-title"
                :span="24"
              >
                建筑物信息
              </el-col>
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-table
                  :data="detail.jzwList || []"
                  border
                  size="small"
                  class="jxxf-project-building-table"
                >
                  <el-table-column
                    prop="jzwmc"
                    label="建筑物名称"
                    min-width="160"
                  />
                  <el-table-column
                    prop="jzdz"
                    label="建筑物地址"
                    min-width="220"
                  />
                  <el-table-column
                    prop="dscs"
                    label="地上层数"
                    width="90"
                  />
                  <el-table-column
                    prop="dxcs"
                    label="地下层数"
                    width="90"
                  />
                  <el-table-column
                    prop="jzmj"
                    label="建筑面积"
                    width="110"
                  />
                  <el-table-column
                    prop="jzgd"
                    label="建筑高度"
                    width="110"
                  />
                  <el-table-column
                    prop="xfdts"
                    label="消防电梯数"
                    width="110"
                  />
                </el-table>
                <span
                  v-if="!(detail.jzwList || []).length"
                  class="c-form__read"
                >
                  -
                </span>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="设施资产"
          name="asset"
        >
          <el-form
            ref="assetFilter"
            :model="assetFilter"
            :inline="true"
            label-suffix="："
            class="u-mg-b-10"
          >
            <el-form-item
              label="资产名称"
              prop="zcmc"
            >
              <el-input
                v-model.trim="assetFilter.zcmc"
                clearable
                maxlength="100"
                placeholder="请输入资产名称"
                @keyup.enter.native="searchAssets"
              />
            </el-form-item>
            <el-form-item>
              <k-button
                type="primary"
                icon="kestrel-icon ki-search"
                btn-text="查询"
                :auth-type="false"
                @click="searchAssets"
              />
              <k-button
                icon="kestrel-icon ki-repeat"
                btn-text="重置"
                :auth-type="false"
                @click="resetAssetSearch"
              />
            </el-form-item>
            <el-form-item v-if="isProjectManager">
              <k-button
                type="primary"
                icon="kestrel-icon ki-plus"
                btn-text="新增资产"
                :auth-type="false"
                @click="openAssetCreate"
              />
              <k-button
                type="success"
                icon="kestrel-icon ki-download"
                btn-text="下载导入模板"
                :auth-type="false"
                @click="downloadAssetTemplate"
              />
              <k-button
                type="primary"
                icon="kestrel-icon ki-upload"
                btn-text="导入资产"
                :auth-type="false"
                @click="assetImportVisible = true"
              />
            </el-form-item>
          </el-form>
          <el-table
            :data="assetPage.rows"
            border
            size="small"
            height="calc(100% - 105px)"
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            />
            <el-table-column
              prop="ssmc"
              label="设施系统"
              min-width="150"
            />
            <el-table-column
              prop="jzwmc"
              label="建筑物"
              min-width="150"
            />
            <el-table-column
              prop="zcmc"
              label="资产名称"
              min-width="160"
            />
            <el-table-column
              prop="zcbh"
              label="资产编号/范围"
              min-width="160"
            />
            <el-table-column
              prop="wz"
              label="位置"
              min-width="200"
            />
            <el-table-column
              prop="lc"
              label="楼层"
              min-width="100"
            />
            <el-table-column
              prop="xhgg"
              label="型号规格"
              min-width="140"
            />
            <el-table-column
              prop="bz"
              label="备注"
              min-width="160"
            />
            <el-table-column
              v-if="isProjectManager"
              label="操作"
              width="90"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="u-color-danger"
                  @click="deleteAsset(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="assetPage.pageNo || 1"
            :page-size="assetPage.pageSize"
            :page-sizes="[15, 30, 50, 100]"
            :total="assetPage.total"
            class="u-mg-t-10"
            @current-change="loadAssets"
            @size-change="handleAssetSizeChange"
          />
        </el-tab-pane>
        <el-tab-pane
          label="维保计划信息"
          name="plan"
        >
          <k-table
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="loadPlans"
            @size-change="handleSizeChange"
          >
            <template #jhlx="scope">
              {{ planTypeName(scope.row.jhlx) }}
            </template>
            <template #jhsj="scope">
              {{ formatDate(scope.row.jhsjQ) }} 至 {{ formatDate(scope.row.jhsjZ) }}
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="新增设施资产"
        :visible.sync="assetCreateVisible"
        width="680px"
        :close-on-click-modal="false"
        append-to-body
        @close="closeAssetCreate"
      >
        <el-form
          ref="assetForm"
          :model="assetForm"
          :rules="assetRules"
          label-width="150px"
        >
          <el-form-item
            label="设施系统"
            prop="ssflId"
          >
            <el-select
              v-model="assetForm.ssflId"
              filterable
              placeholder="请选择设施系统"
              style="width: 100%"
            >
              <el-option
                v-for="item in detail.ssflList || []"
                :key="item.uuid"
                :label="item.ssmc"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="建筑物"
            prop="jzwbhOrMc"
          >
            <el-select
              v-model="assetForm.jzwbhOrMc"
              filterable
              placeholder="请选择建筑物"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in detail.jzwList || []"
                :key="`${item.jzwbh || item.jzwmc}-${index}`"
                :label="item.jzwbh ? `${item.jzwbh} - ${item.jzwmc}` : item.jzwmc"
                :value="item.jzwbh || item.jzwmc"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="资产名称"
            prop="zcmc"
          >
            <el-input
              v-model.trim="assetForm.zcmc"
              maxlength="255"
            />
          </el-form-item>
          <el-form-item
            label="位置"
            prop="wz"
          >
            <el-input
              v-model.trim="assetForm.wz"
              maxlength="500"
            />
          </el-form-item>
          <el-form-item
            label="资产编号或编号范围"
            prop="zcbh"
          >
            <el-input
              v-model.trim="assetForm.zcbh"
              maxlength="255"
            />
          </el-form-item>
          <el-form-item label="楼层">
            <el-input
              v-model.trim="assetForm.lc"
              maxlength="64"
            />
          </el-form-item>
          <el-form-item label="型号规格">
            <el-input
              v-model.trim="assetForm.xhgg"
              maxlength="255"
            />
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model.trim="assetForm.bz"
              type="textarea"
              :rows="3"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button
            type="primary"
            :loading="loading"
            @click="createAsset"
          >
            保存
          </el-button>
          <el-button @click="closeAssetCreate">
            取消
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="导入设施资产"
        :visible.sync="assetImportVisible"
        width="620px"
        :close-on-click-modal="false"
        append-to-body
        @close="closeAssetImport"
      >
        <el-form label-width="110px">
          <el-form-item label="导入文件">
            <input
              ref="assetFile"
              type="file"
              accept=".xlsx"
              @change="selectAssetFile"
            >
          </el-form-item>
          <el-form-item label="填写说明">
            <div class="c-form__read">
              仅支持 .xlsx、最大 10M。设施系统和建筑物必须使用下载模板中的有效值；带 * 的列必须填写。
            </div>
          </el-form-item>
          <el-form-item
            v-if="assetImportResult"
            label="导入结果"
          >
            <div class="c-form__read">
              共 {{ assetImportResult.total || 0 }} 条，成功 {{ assetImportResult.successNum || 0 }} 条，失败 {{ assetImportResult.failNum || 0 }} 条。
              <ul v-if="assetImportResult.failNum && assetImportResult.importExcelErrors">
                <li
                  v-for="item in assetImportResult.importExcelErrors"
                  :key="item.id"
                >
                  第{{ item.id }}行：{{ item.desc }}
                </li>
              </ul>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button
            type="primary"
            :loading="loading"
            @click="importAssets"
          >
            导入
          </el-button>
          <el-button @click="closeAssetImport">
            关闭
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { planService } from '../plan/plan.service';
import { projectService } from './project.service';
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil.js';

export default {
  name: 'JxxfWbProjectDetail',
  /** 初始化项目详情和计划分页状态。 */
  data () {
    return {
      loading: false,
      activeName: 'project',
      detail: {},
      isProjectManager: false,
      assetFilter: { zcmc: null },
      trueAssetFilter: {},
      assetPage: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 1
      },
      assetImportVisible: false,
      assetCreateVisible: false,
      selectedAssetFile: null,
      assetImportResult: null,
      assetForm: {
        ssflId: null,
        jzwbhOrMc: null,
        zcmc: null,
        zcbh: null,
        wz: null,
        lc: null,
        xhgg: null,
        bz: null
      },
      assetRules: {
        ssflId: [{ required: true, message: '请选择设施系统', trigger: 'change' }],
        jzwbhOrMc: [{ required: true, message: '请选择建筑物', trigger: 'change' }],
        zcmc: [{ required: true, message: '请输入资产名称', trigger: 'blur' }],
        wz: [{ required: true, message: '请输入位置', trigger: 'blur' }],
        zcbh: [{ required: true, message: '请输入资产编号或编号范围', trigger: 'blur' }]
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      tableColumn: [{
        key: 'index',
        label: '序号',
        align: 'center',
        width: this.$commonConfig.tableWidthConfig.common_xh,
        type: 'index'
      }, {
        key: 'jhmc',
        label: '计划名称',
        align: 'left',
        minWidth: '180',
        type: 'text'
      }, {
        key: 'jhlx',
        slotName: 'jhlx',
        label: '计划类型',
        align: 'center',
        width: '100',
        type: 'text'
      }, {
        key: 'qhbh',
        label: '期号',
        align: 'center',
        width: '120',
        type: 'text'
      }, {
        key: 'jhsj',
        slotName: 'jhsj',
        label: '计划执行周期',
        align: 'center',
        width: '220',
        type: 'text'
      }, {
        key: 'jhztMc',
        label: '计划状态',
        align: 'center',
        width: '100',
        type: 'text'
      }, {
        key: 'nrsl',
        label: '条目数',
        align: 'right',
        width: '90',
        type: 'text'
      }]
    };
  },
  methods: {
    /** 加载当前维保项目的基础信息。 */
    loadDetail () {
      this.loading = true;
      projectService.detail(this.$route.params.xmId).then(rsp => {
        this.detail = rsp.data || {};
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 按页加载当前维保项目下的计划。 */
    loadPlans (pageNo = 1) {
      this.loading = true;
      planService.page({
        xmId: this.$route.params.xmId,
        pageNo,
        pageSize: this.page.pageSize
      }).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 加载当前项目的设施资产台账。 */
    loadAssets (pageNo = 1) {
      projectService.assets(this.$route.params.xmId, Object.assign({}, this.trueAssetFilter, {
        pageNo,
        pageSize: this.assetPage.pageSize
      })).then(rsp => {
        this.assetPage = Object.assign({}, this.assetPage, rsp.data);
      });
    },
    /** 保存资产名称查询条件并从第一页查询。 */
    searchAssets () {
      this.trueAssetFilter = JSON.parse(JSON.stringify(this.assetFilter));
      this.loadAssets(1);
    },
    /** 清空资产名称查询条件。 */
    resetAssetSearch () {
      this.$refs.assetFilter.resetFields();
      this.trueAssetFilter = {};
      this.loadAssets(1);
    },
    /** 修改资产列表每页条数后回到第一页。 */
    handleAssetSizeChange (pageSize) {
      this.assetPage.pageSize = pageSize;
      this.loadAssets(1);
    },
    /** 打开单条资产新增窗口。 */
    openAssetCreate () {
      this.assetCreateVisible = true;
      this.$nextTick(() => this.$refs.assetForm && this.$refs.assetForm.clearValidate());
    },
    /** 保存单条设施资产。 */
    createAsset () {
      this.$refs.assetForm.validate(valid => {
        if (!valid) return;
        this.loading = true;
        projectService.createAsset(this.$route.params.xmId, this.assetForm).then(() => {
          this.$message.success('新增资产成功，已同步未开始的维保计划');
          this.closeAssetCreate();
          this.loadAssets(1);
        }).finally(() => { this.loading = false; });
      });
    },
    /** 关闭并清空单条资产新增窗口。 */
    closeAssetCreate () {
      this.assetCreateVisible = false;
      if (this.$refs.assetForm) this.$refs.assetForm.resetFields();
      Object.keys(this.assetForm).forEach(key => { this.assetForm[key] = null; });
    },
    /** 软删除资产，已冻结到历史计划中的快照不受影响。 */
    deleteAsset (row) {
      this.$confirm(`确认删除资产“${row.zcmc}”（${row.zcbh}）？已有计划快照不会被删除。`, '提示', { type: 'warning' })
        .then(() => projectService.deleteAsset(this.$route.params.xmId, row.uuid))
        .then(() => {
          this.$message.success('删除资产成功，已同步未开始的维保计划');
          const pageNo = this.assetPage.rows.length === 1 && this.assetPage.pageNo > 1
            ? this.assetPage.pageNo - 1 : this.assetPage.pageNo;
          this.loadAssets(pageNo);
        });
    },
    /** 下载当前项目专属资产导入模板。 */
    downloadAssetTemplate () {
      this.loading = true;
      projectService.downloadAssetTemplate(this.$route.params.xmId).then(rsp => {
        downloadFromApiBlobResponse(rsp, '江西维保设施资产导入模板.xlsx');
      }).finally(() => { this.loading = false; });
    },
    /** 保存选择的资产导入文件。 */
    selectAssetFile (event) {
      const files = event.target.files;
      this.selectedAssetFile = files && files.length ? files[0] : null;
    },
    /** 上传资产模板并展示逐行校验结果。 */
    importAssets () {
      if (!this.selectedAssetFile) return this.$message.warning('请先选择要导入的 .xlsx 文件');
      if (!this.selectedAssetFile.name.toLowerCase().endsWith('.xlsx')) return this.$message.warning('仅支持 .xlsx 文件');
      if (this.selectedAssetFile.size / 1024 / 1024 > 10) return this.$message.warning('导入文件不能超过 10M');
      this.loading = true;
      const data = new FormData();
      data.append('file', this.selectedAssetFile);
      projectService.importAssets(this.$route.params.xmId, data).then(rsp => {
        this.assetImportResult = rsp.data || {};
        if (this.assetImportResult.successNum > 0) {
          this.$message.success('资产导入成功，已同步未开始的维保计划');
        }
        this.loadAssets(1);
      }).finally(() => { this.loading = false; });
    },
    /** 关闭资产导入窗口并清理临时数据。 */
    closeAssetImport () {
      this.assetImportVisible = false;
      this.selectedAssetFile = null;
      this.assetImportResult = null;
      if (this.$refs.assetFile) this.$refs.assetFile.value = '';
    },
    /** 使用统一表格组件的页大小重新加载计划。 */
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.loadPlans(1);
    },
    /** 将后端日期值显示为年月日。 */
    formatDate (value) {
      if (value === null || value === undefined || value === '') return '-';
      const raw = Number(value);
      const date = Number.isFinite(raw)
        ? new Date(raw < 100000000000 ? raw * 1000 : raw)
        : new Date(String(value).replace(/-/g, '/'));
      if (Number.isNaN(date.getTime())) return '-';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    /** 将周期代码转换为前端展示名称。 */
    planTypeName (value) {
      return { YD: '月度', JD: '季度', ND: '年度' }[value] || value || '-';
    }
  },
  /** 创建页面时加载项目详情和维保计划。 */
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.loadDetail();
    this.loadPlans();
    this.searchAssets();
  }
};
</script>
